

export enum DatabaseTypesEnum {
    MYSQL = 'mysql',
    POSTGRES = 'postgres'
}
